import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { FaAngleDown } from 'react-icons/fa';
import { ParticipantDeleteMenuItem } from './ParticipantDeleteMenuItem';
import { ParticipantExportMenuItem } from './ParticipantExportMenuItem';

interface Props extends ChakraV3.ButtonProps {
  participantId: string;
  participantName: string;
  isDisabled?: boolean;
}

export const ParticipantActionMenu = (props: Props) => {
  const { participantId, participantName, isDisabled, ...rest } = props;

  return (
    <ChakraV3.Menu.Root lazyMount={true} unmountOnExit={false}>
      <ChakraV3.Menu.Trigger asChild>
        <ChakraV3.Button variant='outline' {...rest}>
          Actions
          <FaAngleDown />
        </ChakraV3.Button>
      </ChakraV3.Menu.Trigger>
      <ChakraV3.Menu.Positioner>
        <ChakraV3.Menu.Content>
          <ParticipantExportMenuItem participantId={participantId} />
          <ParticipantDeleteMenuItem
            participantId={participantId}
            participantName={participantName}
          />
        </ChakraV3.Menu.Content>
      </ChakraV3.Menu.Positioner>
    </ChakraV3.Menu.Root>
  );
};
